// Engelse teksten voor gemiste taken in de ouderapp (zie missedApp.nl.ts).
export const appMissedEn = {
    line: {
        one: '{count} task missed in the past week',
        other: '{count} tasks missed in the past week',
    },
    lineSub: 'Tick off after all or skip',
    open: 'View',
    title: 'Missed',
    description: 'Tasks from the past week that stayed open. Tick them off after all or skip them. Points count as on that day.',
    done: 'Done after all',
    doneLabel: 'Done after all: {title}, {name}',
    skip: 'Skip',
    skipLabel: 'Skip: {title}, {name}',
    undo: 'Undo',
    undoLabel: 'Undo: {title}, {name}',
    markedDone: '{title} ticked off after all',
    markedSkipped: '{title} skipped',
    undone: '{title} is back under missed',
    stateDone: 'Done',
    stateSkipped: 'Skipped',
    allDone: 'Nothing missed any more. All caught up.',
};
//# sourceMappingURL=missedApp.en.js.map